import Prismic from 'prismic-javascript';

const apiEndpoint = process.env.VUE_APP_PRISMIC_API
const accessToken = process.env.VUE_APP_PRISMIC_TOKEN

const prismicApi = Prismic.getApi(apiEndpoint, { accessToken })


export default prismicApi
export { apiEndpoint, accessToken, prismicApi }
